const salesReport = {
  statisticsByStatus: 'Статистика за статусом',
  statisticsByPayments: 'Статистика за платежами',
  from: 'від',
  till: 'до',
  myClients: 'Мої клієнти',
  newClients: 'Нові клієнти',
  showing: 'показується',
  usersOf: 'користувачі',
  noUsersFound: 'користувачів не знайдено',
  managerSuccessfullyChanged: 'Менеджера успішно змінено',
  lastPayments: 'Останні платежі',
  lastPaymentsOf: 'платежі',
  noSalesReportLastPaymentFound: 'Звіт про продажі, останній платіж не знайдено',
  pickReportRange: 'Вибрати діапазон звіту',
  pickUser: 'Вибрати користувача',
  toolbar: {
    totalClients: 'Загальна кількість клієнтів',
    activeClients: 'Активні клієнти',
    paymentsCommited: 'Платежі здійснено',
    myPaymentsTotal: 'Загальна сума моїх платежів',
  },
  actionDropdown: {
    changeStatus: 'Змінити статус',
    statusHistory: 'Історія статусів',
    editUser: 'Редагувати користувача',
  },
  modal: {
    clientStatusAndNotes: 'Статус клієнта та примітки',
    status: 'Статус',
    note: 'Примітка',
    statusChanged: 'Додано нову примітку або статус'
  }
};
export default salesReport;
